export default __webpack_public_path__ + "static/media/bravo.25365a2c.webp";